import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const Quote = ({ slice }) => {
  return (
    <section className='component-quote w-full bg-stone-700 p-10'>
      <blockquote className='relative mx-auto max-w-screen-xl md:flex md:flex-grow md:flex-col px-4'>
        <div className='relative font-serif text-white md:flex-grow text-center prose prose-2xl mx-auto'>
          <PrismicRichText field={slice.primary.quote.richText} />
        </div>
        <footer className='mt-8 mb-3 flex items-center justify-center'>
          {slice.primary.image.gatsbyImageData && (
            <div className='inline-flex flex-shrink-0 mr-4'>
              <div className='transform  transition duration-500'>
                <GatsbyImage className='z-10 h-24 w-24 overflow-hidden rounded-full border-2 border-white bg-cyan-500' image={getImage(slice.primary.image)} alt={slice.primary.image.alt || ''} />
              </div>
            </div>
          )}
          <div className='text-center'>
            <p className='text-base font-medium text-white'>{slice.primary.author}</p>
            <p className='text-sm font-medium text-stone-200'>
              {slice.primary.role && <span>{slice.primary.role}</span>}
              {slice.primary.company && slice.primary.role && ','}
              {slice.primary.company && <span> {slice.primary.company}</span>}
            </p>
          </div>
        </footer>
      </blockquote>
    </section>
  )
}

export default Quote
